import React, { useState, useRef, useEffect } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import axios from 'axios';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const baseURL = process.env.REACT_APP_API_BASE_URL;

const NeededRawMaterial = ({ show, onClose , selectedDate}) => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const tableRef = useRef(null);

    // const [date, setDate] = useState(format(new Date(), 'yyyy-MM-dd'));
    
        const [date, setDate] = useState(
    selectedDate ? format(new Date(selectedDate), 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd')
);
    const [datas, setData] = useState([]);
    const [sampleData, setSampleData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [loading, setLoading] = useState(false);
    const [itemCount, setItemCount] = useState(0);
    const [rawCount, setRawCount] = useState(0);
    const [buttonStatus, setButtonStatus] = useState(0);
    const [requestSent, setRequestSent] = useState(false); // <-- new state

    const formatDate = (dateStr) => {
        const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        const d = new Date(dateStr);
        const day = String(d.getDate()).padStart(2,'0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const fetchData = () => {
        setLoading(true);

        axios.get(`${baseURL}/menu-raw`, { params: { date } })
            .then(response => {
                const rawSummary = response.data.total_raw_materials || {};
                const items = response.data.sample_data || [];

                setSampleData(items); // needed for payload
                setData(rawSummary.rawmaterial_summary || []);
                setItemCount(rawSummary.no_items || 0);
                setRawCount(rawSummary.no_rawmaterial || 0);
                setButtonStatus(5);
                setHasFetched(true);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching raw material summary:', error);
                toast.error("Failed to fetch raw materials.");
                setHasFetched(true);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [date]);

    const buildPayload = (sampleData) => {
        const payload = {};

        sampleData.forEach(item => {
            const dateKey = item.dailyorder_date;

            if (!payload[dateKey]) {
                payload[dateKey] = [];
            }

            payload[dateKey].push({
                item_id: item.item_id,
                schedule_id: item.schedule_id,

                // NEW FIELDS REQUIRED BY BACKEND
                master_id: item.assigned_staff_id, 
                item_quantity: item.order_quantity,
                item_unit: item.order_unit,   

                // EXTRA FIELDS
                dailyorder_id: item.dailyorder_id,
                dailyorder_date: item.dailyorder_date,
                assigned_staff_id: item.assigned_staff_id,
                order_quantity: item.order_quantity,
                order_unit: item.order_unit,

                // RAW MATERIAL
                raw_material: item.raw_materials.map(rm => ({
                    raw_material_id: rm.raw_material_id,
                    raw_material_name: rm.raw_material_name,
                    quantity: rm.quantity,
                    label_unit: rm.label_unit,
                    rawmaterial_status: 0 // pending
                }))
            });
        });

        return payload;
    };

    const handleRequest = () => {
        if (!sampleData.length) {
            toast.error("No items to request!");
            return;
        }

        const payload = buildPayload(sampleData);

        axios.post(`${baseURL}/stock-requests`, payload)
            .then(() => {
                toast.success("Stock request saved successfully!");
                setRequestSent(true); // hide button
                // onClose(); // optional: only close if you want
            })
            .catch(error => {
                console.error('Error requesting stock:', error);
                toast.error("Failed to save stock request!");
            });
    };

    return (
        <Modal show={show} size="md" onHide={onClose}>
            <div className="modal-content border rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Needed RawMaterial</h3>
                    <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>

                <div className="modal-body">

                    <div className='row mb-2'>
                        <div className='col-lg-4 d-flex flex-column mb-4'>
                            <label className="fs-7 text-black mb-0 font-w500">Date</label>
                            <span className="fs-6 text-danger mb-0 font-w500">{formatDate(date)}</span>
                        </div>

                        <div className='col-lg-4 d-flex flex-column mb-4'>
                            <label className="fs-7 text-black mb-0 font-w500">Total Items</label>
                            <span>
                                <Badge bg="badge-circle" className='badge-outline-danger ms-2 fw-bold fs-6'>{itemCount}</Badge>
                            </span>
                        </div>

                        <div className='col-lg-4 d-flex flex-column mb-4'>
                            <label className="fs-7 text-black mb-0 font-w500">Raw Materials</label>
                            <span>
                                <Badge bg="badge-circle" className='badge-outline-danger ms-2 fw-bold fs-6'>{rawCount}</Badge>
                            </span>
                        </div>
                    </div>

                    {/* Table */}
                    <div 
                        className="table-container"
                        style={{
                            maxHeight: datas.length > 8 ? "400px" : "auto",
                            overflowY: datas.length > 8 ? "auto" : "visible"
                        }}
                    >
                        <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                            <thead>
                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                    <th className='min-w-250px'>Raw Material</th>
                                    <th className='min-w-100px text-center'>Quantity</th>
                                </tr>
                            </thead>

                            <tbody className="text-gray-600 fw-semibold fs-7">
                                {datas.length === 0 && hasFetched ? (
                                    <tr>
                                        <td colSpan="2" className="text-center text-muted py-2">No data available</td>
                                    </tr>
                                ) : (
                                    datas.map((data) => (
                                        <tr key={data.raw_material_id}>
                                            <td>
                                                <div className="fs-7 text-black mb-0 font-w500">{data.raw_material_name}</div>
                                            </td> 
                                            <td className='text-black text-end'>
                                                {parseFloat(data.quantity).toLocaleString(undefined, { 
                                                    minimumFractionDigits: 0, 
                                                    maximumFractionDigits: 3 
                                                })} {data.label_unit}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    {!requestSent && datas.length > 0 && (
                        <div className="mt-3 text-end">
                            <Button variant="primary" onClick={handleRequest}>
                                Request Raw Materials
                            </Button>
                        </div>
                    )}

                </div>
            </div>
        </Modal>
    );
};

export default NeededRawMaterial;
